import { createSlice, createSelector } from '@reduxjs/toolkit'
import { Range } from 'react-date-range'
import { DEFINEDS } from '../../constants/date'

export interface SerializedRange {
  startDate: string
  endDate: string
  key: string
}

export interface InitState {
  calendarRange: Array<SerializedRange>
  calendarRangeCommon: Array<SerializedRange>
  selectedTrucks: { id: string; name: string }[]
  selectedDrivers: { id: string; name: string }[]
  selectedStatus: string[]
  selectedUsersCommon: { id: string | number; name: string }[]
  selectedStatusCommon: string[]
}

const getSessionStorageData = (key: string) => {
  const data = sessionStorage.getItem('reportFilter')
  return data ? JSON.parse(data)[key] : null
}
const calendarStorage = getSessionStorageData('calendarRange')
const calendarCommonStorage = getSessionStorageData('calendarRangeCommon')

const storedSelectedTrucks = getSessionStorageData('selectedTrucks')
const storedSelectedDrivers = getSessionStorageData('selectedDrivers')
const storedSelectedStatus = getSessionStorageData('selectedStatus')
const storedSelectedUsersCommon = getSessionStorageData('selectedUsersCommon')
const storedSelectedStatusCommon = getSessionStorageData('selectedStatusCommon')

const initialState: InitState = {
  calendarRangeCommon: [
    {
      startDate: calendarCommonStorage?.[0]
        ? calendarCommonStorage[0].startDate
        : DEFINEDS.startOfCurrent.toISOString(),
      endDate: calendarCommonStorage?.[0]
        ? calendarCommonStorage[0].endDate
        : DEFINEDS.endOfCurrent.toISOString(),
      key: 'selection',
    },
  ],
  calendarRange: [
    {
      startDate: calendarStorage?.[0]
        ? calendarStorage[0].startDate
        : DEFINEDS.startOfCurrent.toISOString(),
      endDate: calendarStorage?.[0]
        ? calendarStorage[0].endDate
        : DEFINEDS.endOfCurrent.toISOString(),
      key: 'selection',
    },
  ],
  selectedTrucks: storedSelectedTrucks?.length ? storedSelectedTrucks : [],
  selectedDrivers: storedSelectedDrivers?.length ? storedSelectedDrivers : [],
  selectedStatus: storedSelectedStatus?.length ? storedSelectedStatus : [],
  selectedUsersCommon: storedSelectedUsersCommon?.length
    ? storedSelectedUsersCommon
    : [],
  selectedStatusCommon: storedSelectedStatusCommon?.length
    ? storedSelectedStatusCommon
    : [],
}

const updateSessionStorage = (key: string, value: any) => {
  const currentData = JSON.parse(sessionStorage.getItem('reportFilter') || '{}')
  currentData[key] = value
  sessionStorage.setItem('reportFilter', JSON.stringify(currentData))
}

export const reportFilterSlice = createSlice({
  name: 'reportFilter',
  initialState,
  reducers: {
    setCalendarRange: (state, action) => {
      // Сериализуем Date объекты в строки
      const serializedPayload = action.payload.map((range: Range) => ({
        startDate:
          range.startDate instanceof Date
            ? range.startDate.toISOString()
            : range.startDate,
        endDate:
          range.endDate instanceof Date
            ? range.endDate.toISOString()
            : range.endDate,
        key: range.key,
      }))
      const newState = { ...state, calendarRange: serializedPayload }
      updateSessionStorage('calendarRange', serializedPayload)
      return newState
    },
    setCalendarRangeCommon: (state, action) => {
      // Сериализуем Date объекты в строки
      const serializedPayload = action.payload.map((range: Range) => ({
        startDate:
          range.startDate instanceof Date
            ? range.startDate.toISOString()
            : range.startDate,
        endDate:
          range.endDate instanceof Date
            ? range.endDate.toISOString()
            : range.endDate,
        key: range.key,
      }))
      const newState = { ...state, calendarRangeCommon: serializedPayload }
      updateSessionStorage('calendarRangeCommon', serializedPayload)
      return newState
    },
    setSelectedTrucks: (state, action) => {
      state.selectedTrucks = action.payload
      updateSessionStorage('selectedTrucks', action.payload)
    },
    setSelectedDrivers: (state, action) => {
      state.selectedDrivers = action.payload
      updateSessionStorage('selectedDrivers', action.payload)
    },
    setSelectedStatus: (state, action) => {
      state.selectedStatus = action.payload
      updateSessionStorage('selectedStatus', action.payload)
    },
    setSelectedUsersCommon: (state, action) => {
      state.selectedUsersCommon = action.payload
      updateSessionStorage('selectedUsersCommon', action.payload)
    },
    setSelectedStatusCommon: (state, action) => {
      state.selectedStatusCommon = action.payload
      updateSessionStorage('selectedStatusCommon', action.payload)
    },
  },
})

export const {
  setCalendarRange,
  setSelectedTrucks,
  setSelectedDrivers,
  setSelectedStatus,
  setSelectedUsersCommon,
  setSelectedStatusCommon,
  setCalendarRangeCommon,
} = reportFilterSlice.actions

// Селектор для получения дат в виде Date объектов
export const selectCalendarRangeWithDates = createSelector(
  [(state: { reportFilter: InitState }) => state.reportFilter],
  (reportFilter) => ({
    ...reportFilter,
    calendarRange: reportFilter.calendarRange.map((range) => ({
      ...range,
      startDate: new Date(range.startDate),
      endDate: new Date(range.endDate),
    })),
    calendarRangeCommon: reportFilter.calendarRangeCommon.map((range) => ({
      ...range,
      startDate: new Date(range.startDate),
      endDate: new Date(range.endDate),
    })),
  })
)

export default reportFilterSlice.reducer
